export default __webpack_public_path__ + "static/portable-4af0ba101ed7425df8a4abadd6f7c270.jpeg";